// eslint-disable-next-line import/no-unresolved
import React, {Fragment} from 'react';
// eslint-disable-next-line import/no-unresolved
import axios from 'axios';

import translations from '../../../constants/translations';
import TicketsWhite from '.';


/* eslint-disable */
/**
 * Header Provider HOC
 */
class TicketsProvider extends React.Component {
  constructor(){
    super();
    this.state = {
      fullData: null,
      position: null
    }
  }

  componentDidMount() {
    if( typeof navigator !== 'undefined' ) {
      const location = navigator.geolocation;
      if (location) {
        location.getCurrentPosition((pos) => {
          console.log(pos);
          this.setState({position: pos});
        })
      }
    }

    axios.get(`${process.env.GATSBY_BASE_API}/cbx/tickets/config`).then((data)=>{
      this.setState({
        fullData: {
          tickets: {
            edges: [
              {node: data.data.data}
            ]
          }
        }
      });
    })

  }

  render() {
    const {fullData: data, position} = this.state;
    let { locale, user, uid, page, url } = this.props;
    if (!data) {
      return <Fragment>Loading...</Fragment>
    }
    const south = {
      abbreviatedPlace: 'tij',
      place: 'Tijuana'
    };
    const north = {
      abbreviatedPlace: 'tjx',
      place: 'San Diego'
    };
    const ticketTypeESOptions = data.tickets.edges[0].node.ProdClassifications.filter(
      prodClassification => prodClassification.IdLanguage === 1
    ).map(prodClassification => {
      return {
        name: prodClassification.ProductClassification,
        value: prodClassification.IdProdClassification,
        company: prodClassification.IdCompany
      };
    });
    const ticketTypeENOptions = data.tickets.edges[0].node.ProdClassifications.filter(
      prodClassification => prodClassification.IdLanguage === 2
    ).map(prodClassification => {
      return {
        name: prodClassification.ProductClassification,
        value: prodClassification.IdProdClassification,
        company: prodClassification.IdCompany
      };
    });
    const ticketTypeES = {
      name: 'Ticket',
      options: ticketTypeESOptions
    };

    const ticketTypeEN = {
      name: 'Ticket',
      options: ticketTypeENOptions
    };

    const travelTypeES = {
      name: 'Viaje',
      options: [
        {
          name: 'Sencillo',
          value: 'oneway'
        },
        {
          name: 'Redondo',
          value: 'roundtrip'
        }
      ]
    };

    const travelTypeEN = {
      name: 'Type',
      options: [
        {
          name: 'One Way',
          value: 'oneway'
        },
        {
          name: 'Round trip',
          value: 'roundtrip'
        }
      ]
    };

    const travelPurposeES = {
      name: 'Motivo de Viaje',
      options: [
        {
          name:'Seleccionar',
          value:''
        },
        {
          name: 'Visita a amigos o familiares',
          value: 'visit'
        },
        {
          name: 'Placer',
          value: 'leisure'
        },
        {
          name: 'Negocios',
          value: 'business'
        },
        {
          name: 'Otro',
          value: 'other'
        }
      ]
    };

    const travelPurposeEN = {
      name: 'Travel Purpose',
      options: [
        {
          name:'Select',
          value:''
        },
        {
          name: 'Visit friends or relatives',
          value: 'visit'
        },
        {
          name: 'Leisure',
          value: 'leisure'
        },
        {
          name: 'Business',
          value: 'business'
        },
        {
          name: 'Other',
          value: 'other'
        }
      ]
    };

    const packages = data.tickets.edges[0].node.Buttons;
    if (packages.length === 9) {
      packages.splice(0, 1);
    }
    if(typeof page === 'undefined'){
      page = 'home';
    }
    return (
      <TicketsWhite
        packages={packages}
        locale={locale}
        south={south}
        north={north}
        ticketType={locale === 'es' ? ticketTypeES : ticketTypeEN}
        travelType={locale === 'es' ? travelTypeES : travelTypeEN}
        travelPurposes={locale === 'es' ? travelPurposeES : travelPurposeEN}
        translations={locale === 'es' ? translations.es : translations.en}
        user={user}
        uid={uid}
        page={page}
        url={url}
        position={position}
      />
    );
  }
}
export default TicketsProvider;
